import { useState, useEffect } from 'react';
import { Button, Divider } from '@mui/material';
import { Search, Refresh } from '@mui/icons-material';
import { createTheme, CircularProgress } from '@mui/material';

import './drawer-structure.styles.scss';
import { Toastify } from 'lift-ui';
import apiClient from '@lift-admin/utils/apiClient';
import Items from './drawer-parts/items';
import Groupings from './drawer-parts/groupings';
import Modules from './drawer-parts/modules';
import Reports from './drawer-parts/report';
import UIComponents from './drawer-parts/ui-components';
import Channels from './drawer-parts/channels';
import CustomComponents from './drawer-parts/custom-components';
import ReportsSandbox from './drawer-parts/report-sandbox';

const DrawerStructure = () => {
  const [toggle, setToggle] = useState<any>('items');
  const [modules, setModules] = useState<any>([]);
  const [channels, setChannels] = useState<any>([]);
  const [groupings, setGroupings] = useState<any>([]);
  const [component, setComponent] = useState<any>([]);
  const [customComponents, setCustomComponents] = useState<any>([]);
  const [drawerItemsDynamic, setDrawerItemsDynamic] = useState<any>([]);
  const [reports, setReports] = useState<any>([]);
  const [reportsSandbox, setReportsSandbox] = useState<any>([]);
  const [organizations, setOrganization] = useState([]);
  const [brands, setBrands] = useState([]);
  // for post request

  // for dialog
  const [openDialog, setOpenDialog] = useState<any>({
    item: false,
    grouping: false,
    channel: false,
    module: false,
    uiComponent: false,
    customComponent: false,
    reportSandbox: false,
    report: false,
  });

  const [loadData, setLoadData] = useState<boolean>(false);

  const updateDataOnToggle = (toggleActionName: any) => {
    setSearchText('');
    setToggle(toggleActionName);
  };
  const getModules = async () => {
    setLoadData(true);
    try {
      const res = await apiClient.get(
        '/drawer/v1/admin/drawer/structure/modules'
      );

      setModules(res?.data?.response?.modules);
    } catch {
      Toastify('error', 'Modules not fetched');
    } finally {
      setLoadData(false);
    }
  };
  const getChannels = async () => {
    setLoadData(true);
    try {
      const res = await apiClient.get(
        '/drawer/v1/admin/drawer/structure/channels'
      );

      setChannels(res?.data?.response?.channels);
    } catch {
      Toastify('error', 'Channels not fetched');
    } finally {
      setLoadData(false);
    }
  };
  const getDrawrGroupings = async () => {
    setLoadData(true);
    try {
      const res = await apiClient.get(
        '/drawer/v1/admin/drawer/structure/grouping'
      );

      setGroupings(res?.data?.response?.grouping);
    } catch {
      Toastify('error', 'Groupings not fetched');
    } finally {
      setLoadData(false);
    }
  };
  const getComponents = async () => {
    setLoadData(true);
    try {
      const res = await apiClient.get(
        '/drawer/v1/admin/drawer/structure/ui-components'
      );

      setComponent(res?.data?.response?.uiComponents);
    } catch {
      Toastify('error', 'Components not fetched');
    } finally {
      setLoadData(false);
    }
  };
  const getCustomComponents = async () => {
    setLoadData(true);
    try {
      const res = await apiClient.get(
        '/drawer/v1/admin/drawer/structure/custom-components'
      );

      setCustomComponents(res?.data?.response?.customComponents);
    } catch {
      Toastify('error', 'Components not fetched');
    } finally {
      setLoadData(false);
    }
  };
  const getDrawerItemsDynamic = async () => {
    setLoadData(true);
    try {
      const res = await apiClient.get(
        '/drawer/v1/admin/drawer/structure/drawer-items-dynamic'
      );

      setDrawerItemsDynamic(res?.data?.response?.drawerItems);
    } catch {
      Toastify('error', 'Components not fetched');
    } finally {
      setLoadData(false);
    }
  };
  const getReports = async () => {
    setLoadData(true);
    try {
      const res = await apiClient.get(
        '/drawer/v1/admin/drawer/structure/drawer-items-reports'
      );

      setReports(res?.data?.response?.drawerReport);
    } catch {
      Toastify('error', 'Reports not fetched');
    } finally {
      setLoadData(false);
    }
  };

  const getReportsSandbox = async () => {
    setLoadData(true);
    try {
      const res = await apiClient.get(
        '/drawer/v1/admin/drawer/structure/drawer-items-reports-sandbox'
      );

      setReportsSandbox(res?.data?.response?.drawerReport);
    } catch {
      Toastify('error', 'Reports not fetched');
    } finally {
      setLoadData(false);
    }
  };

  const user = JSON.parse(localStorage.getItem('user') as any);
  const getAllbrands = async () => {
    const res = await apiClient.get(
      `/brand/v1/admin/brands/allFields/${user.id}`
    );
    ;

    setBrands(res.data.response);
  };
  const customSortBasedOnDate = (a: any, b: any) => {
    return new Date(a.created_at).getTime() - new Date(b.created_at).getTime();
  };

  const getAllOrgnaizations = async () => {
    const res = await apiClient.get(`/brand/v1/organizations/all`);
    setOrganization(res.data.response.sort(customSortBasedOnDate).reverse());
  };

  const callAllApi = async () => {
    getAllbrands();
    getAllOrgnaizations();
    getChannels();
    getModules();
    getDrawrGroupings();
    getComponents();
    getCustomComponents();
    getDrawerItemsDynamic();
    getReports();
    getReportsSandbox();
  };

  useEffect(() => {
    callAllApi();
  }, []);

  const handleAddClick = (toggle: string) => {
    if (toggle === 'items') {
      setOpenDialog((prev: any) => ({ ...prev, item: true }));
    }
    if (toggle === 'groupings') {
      setOpenDialog((prev: any) => ({ ...prev, grouping: true }));

    }
    if (toggle === 'channels') {
      setOpenDialog((prev: any) => ({ ...prev, channel: true }));
    }
    if (toggle === 'modules') {
      setOpenDialog((prev: any) => ({ ...prev, module: true }));
    }
    if (toggle === 'ui-components') {
      setOpenDialog((prev: any) => ({ ...prev, uiComponent: true }));
    }
    if (toggle === 'custom-components') {
      setOpenDialog((prev: any) => ({ ...prev, customComponent: true }));
    }

    if (toggle === 'reports') {
      setOpenDialog((prev: any) => ({ ...prev, report: true }));
    }
    if (toggle === 'reports-sandbox') {
      setOpenDialog((prev: any) => ({ ...prev, reportSandbox: true }));
    }
  };

  const [searchText, setSearchText] = useState<any>('');

  useEffect(() => {
    setSearchText('');
  }, [toggle]);
  return (
    <>
      <div className="users">
        <div className="head">
          <div className="head-txt">Drawer Structure</div>
          {loadData ? (
            <CircularProgress
              className="head-refresh"
              size={18}
              style={{ marginLeft: '10px', paddingLeft: '0px' }}
            />
          ) : (
            <Refresh
              className="head-refresh"
              onClick={() => {
                getModules();
                getChannels();
                getDrawrGroupings();
                getComponents();
                getCustomComponents();
                getDrawerItemsDynamic();
                getReports();
                getReportsSandbox();
              }}
              style={{
                cursor: 'pointer',
                color: '#16306D',
                marginLeft: '10px',
              }}
            />
          )}{' '}
          {toggle !== 'channels' &&
            toggle !== 'modules' &&
            toggle !== 'ui-components' &&
            toggle !== 'custom-components' && (
              <Button
                className="add-user-btn"
                onClick={() => handleAddClick(toggle)}
                style={{
                  // marginLeft: "10px",
                  padding: '5px 10px',
                  cursor: 'pointer',
                  backgroundColor: '#16306D',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  height: '50px', // Optional: explicitly set height for uniform size
                  width: 'auto',
                }}>
                Add{' '}
                {toggle === 'items'
                  ? 'Drawer Item'
                  : toggle === 'groupings'
                    ? 'Grouping'
                    : toggle === 'reports'
                      ? 'Report'
                      : toggle === 'reports-sandbox'
                        ? 'Report Sandbox'
                        : 'Item'}
              </Button>
            )}
        </div>

        <div
          className="toggle-div"
          style={{ display: 'flex', alignItems: 'center' }}>
          <div
            className="toggle-content"
            onClick={() => {
              updateDataOnToggle('items');
              callAllApi();
            }}>
            <p className={toggle === 'items' ? 'selected-toggle-text' : ''}>
              Drawer Items
            </p>
            <div
              className={toggle === 'items' ? 'selected-toggle-bar' : ''}></div>
          </div>
          <div
            className="toggle-content"
            onClick={() => updateDataOnToggle('reports')}>
            <p className={toggle === 'reports' ? 'selected-toggle-text' : ''}>
              Reports
            </p>
            <div
              className={
                toggle === 'reports' ? 'selected-toggle-bar' : ''
              }></div>
          </div>
          <div
            className="toggle-content"
            onClick={() => updateDataOnToggle('reports-sandbox')}>
            <p
              className={
                toggle === 'reports-sandbox' ? 'selected-toggle-text' : ''
              }>
              Reports Sandbox
            </p>
            <div
              className={
                toggle === 'reports-sandbox' ? 'selected-toggle-bar' : ''
              }></div>
          </div>
          <div
            className="toggle-content"
            onClick={() => updateDataOnToggle('groupings')}>
            <p className={toggle === 'groupings' ? 'selected-toggle-text' : ''}>
              Groupings
            </p>
            <div
              className={
                toggle === 'groupings' ? 'selected-toggle-bar' : ''
              }></div>
          </div>

          <div
            className="toggle-content"
            onClick={() => updateDataOnToggle('channels')}>
            <p className={toggle === 'channels' ? 'selected-toggle-text' : ''}>
              Channels
            </p>
            <div
              className={
                toggle === 'channels' ? 'selected-toggle-bar' : ''
              }></div>
          </div>
          <div
            className="toggle-content"
            onClick={() => updateDataOnToggle('modules')}>
            <p className={toggle === 'modules' ? 'selected-toggle-text' : ''}>
              Modules
            </p>
            <div
              className={
                toggle === 'modules' ? 'selected-toggle-bar' : ''
              }></div>
          </div>

          <div
            className="toggle-content"
            onClick={() => updateDataOnToggle('ui-components')}>
            <p
              className={
                toggle === 'ui-components' ? 'selected-toggle-text' : ''
              }>
              UI Components
            </p>
            <div
              className={
                toggle === 'ui-components' ? 'selected-toggle-bar' : ''
              }></div>
          </div>
          <div
            className="toggle-content"
            onClick={() => updateDataOnToggle('custom-components')}>
            <p
              className={
                toggle === 'custom-components' ? 'selected-toggle-text' : ''
              }>
              Custom Components
            </p>
            <div
              className={
                toggle === 'custom-components' ? 'selected-toggle-bar' : ''
              }></div>
          </div>

          <div
            className="input-container"
            style={{ display: 'flex', alignItems: 'center' }}>
            <Search className="icon" />
            <input
              className="input-field"
              type="text"
              placeholder="Search..."
              value={searchText}
              onChange={(event) => {
                setSearchText(event.target.value);
              }}
            />
          </div>
        </div>
        <Divider />

        {/* Content */}
        {toggle === 'items' && (
          <Items
            searchText={searchText}
            toggle={toggle}
            modules={modules}
            channels={channels}
            groupings={groupings}
            component={component}
            drawerItemsDynamic={drawerItemsDynamic}
            customComponents={customComponents}
            reports={reports}
            reportsSandbox={reportsSandbox}
            openDialog={openDialog?.item}
            organizations={organizations}
            brands={brands}
            setOpenDialog={(value: boolean) =>
              setOpenDialog((prev: any) => ({ ...prev, item: value }))
            }
          />
        )}
        {toggle === 'groupings' && (
          <Groupings
            searchText={searchText}
            toggle={toggle}
            channels={channels}
            openDialog={openDialog?.grouping}
            brands={brands}
            setOpenDialog={(value: boolean) =>
              setOpenDialog((prev: any) => ({ ...prev, grouping: value }))
            }
          />
        )}
        {toggle === 'modules' && (
          <Modules
            searchText={searchText}
            toggle={toggle}
            brands={brands}
            openDialog={openDialog?.module}
            setOpenDialog={(value: boolean) =>
              setOpenDialog((prev: any) => ({ ...prev, module: value }))
            }
          />
        )}
        {toggle === 'channels' && (
          <Channels
            brands={brands}
            searchText={searchText}
            toggle={toggle}
            openDialog={openDialog?.channel}
            setOpenDialog={(value: boolean) =>
              setOpenDialog((prev: any) => ({ ...prev, channel: value }))
            }
          // handleAddChannel={handleAddChannel}
          />
        )}
        {/* {toggle === "report" && (

          <Reports toggle={toggle} drawerStructure={drawerStructure} />
        )} */}
        {toggle === 'ui-components' && (
          <UIComponents
            searchText={searchText}
            toggle={toggle}
            openDialog={openDialog?.uiComponent}
            setOpenDialog={(value: boolean) =>
              setOpenDialog((prev: any) => ({ ...prev, uiComponent: value }))
            }
          />
        )}
        {toggle === 'custom-components' && (
          <CustomComponents
            searchText={searchText}
            toggle={toggle}
            openDialog={openDialog?.customComponent}
            setOpenDialog={(value: boolean) =>
              setOpenDialog((prev: any) => ({
                ...prev,
                customComponent: value,
              }))
            }
          />
        )}
        {toggle === 'reports' && (
          <Reports
            searchText={searchText}
            setOpenDialog={setOpenDialog}
            toggle={toggle}
            openDialog={openDialog?.report}
            channels={channels}
            modules={modules}
          />
        )}

        {toggle === 'reports-sandbox' && (
          <ReportsSandbox
            searchText={searchText}
            setOpenDialog={setOpenDialog}
            toggle={toggle}
            openDialog={openDialog?.reportSandbox}
          />
        )}

        <div className="foot">
          <p>All rights reserved | New Engen</p>
        </div>
      </div>
    </>
  );
};

export default DrawerStructure;
